'use client'

import { MeetingAttendanceDelivery } from './MeetingAttendanceDelivery'
import PortalThemeProvider from './PortalThemeProvider'
import { SessionProvider } from 'next-auth/react'
import PostHogProvider from './PostHogProvider'
import QueryProvider from './QueryProvider'
import ToasterProvider from './ToasterProvider'
import { NuqsAdapter } from 'nuqs/adapters/next/app'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'

export function AppProviders({
  children,
  session,
  platform = false
}: {
  children: React.ReactNode
  session: any
  platform?: boolean
}) {
  // The platform portal has no tenant attendance delivery, query cache,
  // analytics capture or legacy account-menu mutations.
  if (platform) return <PortalThemeProvider>{children}<ToasterProvider /></PortalThemeProvider>
  return (
    <PortalThemeProvider>
      <SessionProvider session={session}>
        <MeetingAttendanceDelivery />
        <NuqsAdapter>
          <PostHogProvider>
            <QueryProvider>
              {children}
              <ToasterProvider />
              <ReactQueryDevtools initialIsOpen={false} />
            </QueryProvider>
          </PostHogProvider>
        </NuqsAdapter>
      </SessionProvider>
    </PortalThemeProvider>
  )
}
